export const featureFlags = {
  basicTemplateOnly: "basic_template_only",
  deviceGroups: "device_groups",
  deviceScaling: "device_scaling",
  deviceSchedules: "device_schedules",
  hardcodedUrls: "hardcoded_urls",
  nutritionIntegration: "nutrition_integration",
  playlists: "playlists",
  productTours: "product_tours",
  strengthIntegration: "strength_integration",
  weatherConfig: "weather_config",
  hideSchedule: "hide_schedule",
  skipIpValidationForVirtualDevices: "skip_ip_validation_for_virtual_devices",
  verticalDisplays: "vertical_displays",
};
